import { api } from "../api";
import {
  WhatsappTemplateButtonTypeEnum,
  WhatsappTemplateCategoryEnum,
} from "../enums";
import { updateErrorsForCards } from "./updateErrorsForCards";

export async function submitTemplate({
  isInPanel,
  templateName,
  body,
  cards,
  footer,
  flowButton,
  copyCodeButton,
  urlButton,
  urlButtonLink,
  urlButton2,
  urlButtonLink2,
  urlButtonTrackingEnabled,
  urlButton2TrackingEnabled,
  quickReply1,
  quickReply2,
  quickReply3,
  isUrlButtonAtBottom,
  selectedHeader,
  selectedCategory,
  user,
  setErrors,
  setLimitedTimeOfferErrorsMap,
  setTemplateNameError,
  setBodyError,
  setLinkError,
  setLinkTextError,
  setLink2Error,
  setLinkText2Error,
  setQuickReply1Error,
  setQuickReply2Error,
  setQuickReply3Error,
  setBodyCardErrors,
  setButtonCardErrors,
  setIsSubmitLoading,
  setErrorMessage,
  toggleActiveSumbit,
  toggleActiveErrorSumbitting,
  setProgression,
  templateNameRef,
  bodyRef,
  quickReply1Ref,
  quickReply2Ref,
  quickReply3Ref,
  urlButtonLinkRef,
  urlButtonLink2Ref,
  bodyCardRefs,
  buttonCardRefs,
  setNewTemplateName,
  limitedTimeOffer,
}) {
  let validationErrors = {};
  let firstErrorField = null;

  console.info("[submitTemplate] Initialisation - bodyCardRefs:", bodyCardRefs);
  console.info(
    "[submitTemplate] Initialisation - buttonCardRefs:",
    buttonCardRefs,
  );
  console.info("[submitTemplate] Initialisation - urlButton2:", urlButton2);

  const globalVariables = await api.globalVariable.findMany({
    filter: {
      OR: [
        {
          key: { equals: "imageHandle" },
        },
        {
          key: { equals: "videoHandle" },
        },
      ],
    },
    select: {
      id: true,
      key: true,
      stringValue: true,
    },
  });

  const waPublicLinkImage = globalVariables.find(
    (variable) => variable.key === "imageHandle",
  )?.stringValue;
  const waPublicLinkVideo = globalVariables.find(
    (variable) => variable.key === "videoHandle",
  )?.stringValue;

  console.info("[submitTemplate] Global variables - cards:", cards);

  const delay = (delayInms) => {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
  };

  const cleanTemplateName = (name) =>
    removeEmojisFromText(
      name
        .toLowerCase()
        .replaceAll(" ", "_")
        .replaceAll("-", "_")
        .replaceAll("%", "")
        .replaceAll(",", "")
        .replaceAll(";", "")
        .replaceAll("!", "")
        .replaceAll("?", "")
        .replaceAll("[", "")
        .replaceAll("]", "")
        .replaceAll("'", "")
        .replaceAll(".", "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, ""),
    );

  const removeEmojisFromText = (text) =>
    text.replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      "",
    );

  // Validation des champs
  setTemplateNameError(false);
  setBodyError(false);
  setQuickReply1Error(false);
  setQuickReply2Error(false);
  setQuickReply3Error(false);
  setLinkError(false);
  setLink2Error(false);
  setLimitedTimeOfferErrorsMap(new Map());
  setLinkTextError(false);
  setLinkText2Error(false);

  function containsEmojis(text) {
    const regex =
      /(?:\uD83C[\uDFFB-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD10-\uDDFF]|\uD83D[\uDE00-\uDE4F]|\uD83D[\uDE80-\uDEFF]|\uD83C[\uDDE6-\uDDFF])+/g;
    return text.match(regex)?.length > 0;
  }

  if (!templateName) {
    validationErrors.template_name = "Template name is required";
    setTemplateNameError(true);
    firstErrorField = firstErrorField || templateNameRef;
  }

  if (!body) {
    validationErrors.body = "Body is required";
    setBodyError(true);
    firstErrorField = firstErrorField || bodyRef;
  }

  const validateButton = (
    button,
    buttonLink,
    validationKey,
    setError,
    setTextError,
    ref,
  ) => {
    if (button && !buttonLink) {
      validationErrors[validationKey] = "Link is required";
      setError(true);
      firstErrorField = firstErrorField || ref;
    }

    if (!button && buttonLink) {
      validationErrors[validationKey] = "Title is required";
      setTextError(true);
      firstErrorField = firstErrorField || ref;
    }

    if (button && containsEmojis(button)) {
      validationErrors[`${validationKey}Text`] = "Emoji not allowed in button";
      setTextError(true);
      firstErrorField = firstErrorField || ref;
    }

    if (
      buttonLink &&
      buttonLink.includes("{{1}}") &&
      !buttonLink.trim().endsWith("{{1}}")
    ) {
      validationErrors[validationKey] =
        "URL variable should be at the end of the URL";
      setError(true);
      firstErrorField = firstErrorField || ref;
    }
  };

  // Appel de la fonction pour chaque bouton
  validateButton(
    urlButton,
    urlButtonLink,
    "link",
    setLinkError,
    setLinkTextError,
    urlButtonLinkRef,
  );
  validateButton(
    urlButton2,
    urlButtonLink2,
    "link2",
    setLink2Error,
    setLinkTextError,
    urlButtonLink2Ref,
  );

  if (quickReply1 && containsEmojis(quickReply1)) {
    validationErrors.quickReply1 = "Emoji not allowed in button";
    setQuickReply1Error(true);
    firstErrorField = firstErrorField || quickReply1Ref;
  }

  if (quickReply2 && containsEmojis(quickReply2)) {
    validationErrors.quickReply2 = "Emoji not allowed in button";
    setQuickReply2Error(true);
    firstErrorField = firstErrorField || quickReply2Ref;
  }

  if (quickReply3 && containsEmojis(quickReply3)) {
    validationErrors.quickReply3 = "Emoji not allowed in button";
    setQuickReply3Error(true);
    firstErrorField = firstErrorField || quickReply3Ref;
  }

  // Validate the section Limited-Time offer
  if (selectedCategory === WhatsappTemplateCategoryEnum.LIMITED_TIME_OFFER) {
    const errorMessages = {
      text: "Text is required",
    };
    if (!urlButtonLink) {
      validationErrors.link = "Link is required";
      setLinkError(true);
    }
    if (!limitedTimeOffer) {
      validationErrors.limitedTimeOffer = {
        text: errorMessages.text,
      };
      setLimitedTimeOfferErrorsMap((previous) => {
        const updatedMap = new Map(previous);
        updatedMap.set("text", true);
        return updatedMap;
      });
    } else {
      const { text } = limitedTimeOffer;
      if (!text) {
        validationErrors.limitedTimeOffer = {
          text: text ? undefined : errorMessages.text,
        };

        setLimitedTimeOfferErrorsMap((previous) => {
          const _limitedTimeOfferErrorsMap = new Map(previous);
          if (!text) {
            _limitedTimeOfferErrorsMap.set("text", true);
          }
          return _limitedTimeOfferErrorsMap;
        });
      }
    }
  }

  if (selectedCategory === WhatsappTemplateCategoryEnum.CAROUSEL) {
    updateErrorsForCards(cards, setBodyCardErrors, setButtonCardErrors);
    console.info(
      "[submitTemplate] Carousel validation - bodyCardRefs:",
      bodyCardRefs,
    );

    const newBodyErrors = {};
    const newButtonErrors = {};

    cards.forEach((card, cardIndex) => {
      const bodyComponent = card.components.find((c) => c.type === "BODY");
      const bodyText = bodyComponent?.text || "";

      if (!bodyText.trim()) {
        newBodyErrors[cardIndex] = "Body is required";
        validationErrors[`body-${cardIndex}`] = true;
        firstErrorField = firstErrorField || bodyCardRefs.current[cardIndex];
        setBodyError(true);
      }

      newButtonErrors[cardIndex] = {};

      card.components
        .filter((c) => c.type === "BUTTONS")
        .forEach((comp) => {
          comp.buttons.forEach((button, buttonIndex) => {
            newButtonErrors[cardIndex][buttonIndex] = {};

            if (button.type.toLowerCase() === "url") {
              if (!button.text || !button.text.trim()) {
                newButtonErrors[cardIndex][buttonIndex].title =
                  "Text is required";
                validationErrors[`button-${cardIndex}-${buttonIndex}-title`] =
                  true;
                firstErrorField =
                  firstErrorField ||
                  (buttonCardRefs.current[cardIndex] &&
                    buttonCardRefs.current[cardIndex][buttonIndex]);
              }
              if (button.text && containsEmojis(button.text)) {
                newButtonErrors[cardIndex][buttonIndex].title =
                  "Emoji not allowed in button";
                validationErrors[`button-${cardIndex}-${buttonIndex}-title`] =
                  true;
                firstErrorField =
                  firstErrorField ||
                  (buttonCardRefs.current[cardIndex] &&
                    buttonCardRefs.current[cardIndex][buttonIndex]);
              }
              if (!button.url || !button.url.trim()) {
                newButtonErrors[cardIndex][buttonIndex].url =
                  "Link is required";
                validationErrors[`button-${cardIndex}-${buttonIndex}-url`] =
                  true;
                firstErrorField =
                  firstErrorField ||
                  (buttonCardRefs.current[cardIndex] &&
                    buttonCardRefs.current[cardIndex][buttonIndex]);
              }
            } else if (button.type.toLowerCase() === "quick_reply") {
              if (!button.text || !button.text.trim()) {
                newButtonErrors[cardIndex][buttonIndex].text =
                  "Title is required";
                validationErrors[`button-${cardIndex}-${buttonIndex}-text`] =
                  true;
                firstErrorField =
                  firstErrorField ||
                  (buttonCardRefs.current[cardIndex] &&
                    buttonCardRefs.current[cardIndex][buttonIndex]);
              }
              if (button.text && containsEmojis(button.text)) {
                newButtonErrors[cardIndex][buttonIndex].text =
                  "Emoji not allowed in button";
                validationErrors[`button-${cardIndex}-${buttonIndex}-text`] =
                  true;
                firstErrorField =
                  firstErrorField ||
                  (buttonCardRefs.current[cardIndex] &&
                    buttonCardRefs.current[cardIndex][buttonIndex]);
              }
            }
          });
        });
    });

    // Mise à jour de vos états d'erreur pour le carousel
    setBodyCardErrors(newBodyErrors);
    setButtonCardErrors(newButtonErrors);
  }

  if (isInPanel) {
    console.warn(
      "[submitTemplate] Validation errors (panel):",
      validationErrors,
    );
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.info(
        "[submitTemplate] First error field (panel):",
        firstErrorField?.current,
      );
      if (firstErrorField?.current) {
        firstErrorField.current.focus();
      } else if (firstErrorField) {
        firstErrorField.focus();
      }
      return;
    }
  } else {
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.warn("[submitTemplate] Validation errors:", validationErrors);
      firstErrorField?.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }
  }

  setErrors({});
  setTemplateNameError(false);
  setBodyError(false);
  setLinkError(false);
  setLinkTextError(false);

  if (isInPanel) {
    updateErrorsForCards(cards, setBodyCardErrors, setButtonCardErrors);
    setIsSubmitLoading(true);
  }

  var submittedTemplate = {
    name: cleanTemplateName(templateName),
    language: "fr",
    category:
      selectedCategory === WhatsappTemplateCategoryEnum.LIMITED_TIME_OFFER ||
      selectedCategory === WhatsappTemplateCategoryEnum.CAROUSEL
        ? WhatsappTemplateCategoryEnum.MARKETING
        : (selectedCategory ?? WhatsappTemplateCategoryEnum.UTILITY),
    components: [],
  };

  // Ajout de l'en-tête en fonction de la sélection
  if (selectedHeader[0] === "image") {
    const imageHandle = user?.customer?.waAccessToken
      ? waPublicLinkImage
      : "https://firebasestorage.googleapis.com/v0/b/phocea-75b47.appspot.com/o/Compa%2Fph_image.png?alt=media&token=b42e2452-09c4-4076-9956-15520363da4b";
    submittedTemplate.components.push({
      type: "HEADER",
      format: "IMAGE",
      example: {
        header_handle: [imageHandle],
      },
    });
  } else if (selectedHeader[0] === "video") {
    const videoHandle = user?.customer?.waAccessToken
      ? waPublicLinkVideo
      : "https://firebasestorage.googleapis.com/v0/b/phocea-75b47.appspot.com/o/Compa%2FVideo%20Noe%CC%88l%20format%20carre%CC%81.mp4?alt=media&token=c9c0e395-5ea6-49f8-bb30-3d20d85cd943";
    submittedTemplate.components.push({
      type: "HEADER",
      format: "VIDEO",
      example: {
        header_handle: [videoHandle],
      },
    });
  }

  // Ajout du corps
  if (body !== "") {
    var component = {
      type: "BODY",
      text: body,
    };
    let k = 1;
    while (body.includes(`{{${k}}}`)) {
      if (k === 1) {
        component.example = {
          body_text: [["Emilia"]],
        };
      } else {
        component.example.body_text[0].push("Marie");
      }
      k++;
    }
    submittedTemplate.components.push(component);
  }

  let officialUrlButtons = [];
  if (cards) {
    let imageHeader, videoHeader;

    // Récupération du premier composant de type CAROUSEL
    console.info("[submitTemplate] Carousel processing - cards:", cards);
    const firstCarouselComponent = cards[0]?.components.find(
      (c) => c.type === "HEADER",
    );
    console.info(
      "[submitTemplate] Carousel processing - first card:",
      cards[0],
    );
    console.info(
      "[submitTemplate] Carousel processing - first carousel component:",
      firstCarouselComponent,
    );

    if (firstCarouselComponent?.format.toLowerCase() === "image") {
      imageHeader = {
        type: "HEADER",
        format: "IMAGE",
        example: {
          header_handle: [
            user?.customer?.waAccessToken
              ? waPublicLinkImage
              : "https://firebasestorage.googleapis.com/v0/b/phocea-75b47.appspot.com/o/Compa%2Fph_image.png?alt=media&token=b42e2452-09c4-4076-9956-15520363da4b",
          ],
        },
      };
    } else {
      videoHeader = {
        type: "HEADER",
        format: "VIDEO",
        example: {
          header_handle: [
            user?.customer?.waAccessToken
              ? waPublicLinkVideo
              : "https://firebasestorage.googleapis.com/v0/b/phocea-75b47.appspot.com/o/Compa%2FVideo%20Noe%CC%88l%20format%20carre%CC%81.mp4?alt=media&token=c9c0e395-5ea6-49f8-bb30-3d20d85cd943",
          ],
        },
      };
    }

    // Ajout des exemples dans chaque carte
    const updatedCards = cards.map((card) => {
      const bodyComponent = card.components.find((c) => c.type === "BODY");
      const bodyText = bodyComponent ? bodyComponent.text : "";

      const buttonsComponent = card.components.find(
        (c) => c.type === "BUTTONS",
      );

      // console.log(buttonsComponent);
      const urlButtons =
        buttonsComponent?.buttons.filter(
          (c) => c.type === "URL" || c.type === "url",
        ) || [];
      officialUrlButtons.push(urlButtons);

      // console.log(imageHeader);
      const updatedCard = {
        components: [
          firstCarouselComponent?.format.toLowerCase() === "image"
            ? imageHeader
            : videoHeader,
          {
            type: "BODY",
            text: bodyText,
          },
          {
            type: "BUTTONS",
            buttons: [],
          },
        ],
      };

      // SP-8442 FIXME should create a redirection record to track the clicks on the buttons.
      // ici on cree des redirection en mode example. au moment de l envoie, on doit creer des redirection reelles.
      buttonsComponent?.buttons.forEach((button) => {
        if (button.type === "URL" || button.type === "url") {
          const updatedUrlButton = button.url.includes("{{1}}")
            ? {
                type: "URL",
                text: button.text,
                url: button.url,
                example: [button.url + "126T783173Y9121B9Q"],
              }
            : {
                type: "URL",
                text: button.text,
                url: `https://${
                  window.gadgetConfig.environment === "production"
                    ? "app.getsimio.com"
                    : `getsimio--${window.gadgetConfig.environment}.gadget.app`
                }/redirect/{{1}}`,
                example: [
                  `https://${
                    window.gadgetConfig.environment === "production"
                      ? "app.getsimio.com"
                      : `getsimio--${window.gadgetConfig.environment}.gadget.app`
                  }/redirect/126T783173Y9121B9Q`,
                ],
              };
          updatedCard.components[2].buttons.push(updatedUrlButton);
        } else if (
          button.type === "QUICK_REPLY" ||
          button.type === "quick_reply"
        ) {
          updatedCard.components[2].buttons.push({
            type: "QUICK_REPLY",
            text: button.text,
          });
        }
      });

      // Ajouter des exemples pour les variables dans le texte du corps
      let k = 1;
      while (bodyText.includes(`{{${k}}}`)) {
        if (k === 1) {
          updatedCard.components[1].example = {
            body_text: [["Emilia"]],
          };
        } else {
          updatedCard.components[1].example.body_text[0].push("Marie");
        }
        k++;
      }

      return updatedCard;
    });

    // Ajout au template final
    const carousel = {
      type: "CAROUSEL",
      cards: updatedCards,
    };
    submittedTemplate.components.push(carousel);
  } else {
    // Ajout du pied de page
    if (footer !== "") {
      submittedTemplate.components.push({
        type: "FOOTER",
        text: footer,
      });
    }

    // Ajout des boutons
    if (
      flowButton ||
      urlButton !== "" ||
      quickReply1 !== "" ||
      quickReply2 !== "" ||
      quickReply3 !== ""
    ) {
      var buttons = {
        type: "BUTTONS",
        buttons: [],
      };

      if (flowButton) {
        const { flowId, flowAction, navigateScreen, text } = flowButton;
        buttons.buttons.push({
          flow_id: flowId,
          flow_action: flowAction,
          navigate_screen: navigateScreen,
          text,
          type: WhatsappTemplateButtonTypeEnum.FLOW,
        });
      }
      if (quickReply1 !== "") {
        buttons.buttons.push({
          type: WhatsappTemplateButtonTypeEnum.QUICK_REPLY,
          text: quickReply1,
        });
      }
      if (quickReply2 !== "") {
        buttons.buttons.push({
          type: WhatsappTemplateButtonTypeEnum.QUICK_REPLY,
          text: quickReply2,
        });
      }
      if (quickReply3 !== "") {
        buttons.buttons.push({
          type: WhatsappTemplateButtonTypeEnum.QUICK_REPLY,
          text: quickReply3,
        });
      }
      if (urlButton !== "") {
        const urlButtonToPush =
          urlButtonLink?.includes("{{1}}") ||
          (urlButtonTrackingEnabled ?? true) === false
            ? {
                type: WhatsappTemplateButtonTypeEnum.URL,
                text: urlButton,
                url: urlButtonLink,
                example: [urlButtonLink + "126T783173Y9121B9Q"],
              }
            : {
                type: WhatsappTemplateButtonTypeEnum.URL,
                text: urlButton,
                url: `https://${
                  window.gadgetConfig.environment === "production"
                    ? "app.getsimio.com"
                    : `getsimio--${window.gadgetConfig.environment}.gadget.app`
                }/redirect/{{1}}`,
                example: [
                  `https://${
                    window.gadgetConfig.environment === "production"
                      ? "app.getsimio.com"
                      : `getsimio--${window.gadgetConfig.environment}.gadget.app`
                  }/redirect/126T783173Y9121B9Q`,
                ],
              };

        // Consider to reorder buttons except for LTO where the order is hardcoded (COPY_CODE > URL > QUICK_REPLY).
        if (!limitedTimeOffer || !limitedTimeOffer.text) {
          if (isUrlButtonAtBottom) {
            buttons.buttons.push(urlButtonToPush);
          } else {
            buttons.buttons.unshift(urlButtonToPush);
          }
        } else {
          buttons.buttons.unshift(urlButtonToPush);

          if (copyCodeButton) {
            const { text } = copyCodeButton;
            const _copyCodeButton = {
              type: WhatsappTemplateButtonTypeEnum.COPY_CODE,
              example: [text],
            };
            buttons.buttons.unshift(_copyCodeButton);
          }
        }
      }
      console.info("[submitTemplate] Buttons configuration:", buttons);

      submittedTemplate.components.push(buttons);
    }

    if (limitedTimeOffer?.text) {
      const { text } = limitedTimeOffer;
      submittedTemplate.components.push({
        type: "LIMITED_TIME_OFFER",
        limited_time_offer: { text, has_expiration: true },
      });
    }

    if (urlButton2 && urlButton2 !== "") {
      const urlButton2ToPush =
        urlButtonLink2?.includes("{{1}}") ||
        (urlButton2TrackingEnabled ?? true) === false
          ? {
              type: WhatsappTemplateButtonTypeEnum.URL,
              text: urlButton2,
              url: urlButtonLink2,
              example: [urlButtonLink2 + "126T783173Y9121B9Q"],
            }
          : {
              type: WhatsappTemplateButtonTypeEnum.URL,
              text: urlButton2,
              url: `https://${
                window.gadgetConfig.environment === "production"
                  ? "app.getsimio.com"
                  : `getsimio--${window.gadgetConfig.environment}.gadget.app`
              }/redirect/{{1}}`,
              example: [
                `https://${
                  window.gadgetConfig.environment === "production"
                    ? "app.getsimio.com"
                    : `getsimio--${window.gadgetConfig.environment}.gadget.app`
                }/redirect/126T783173Y9121B9Q`,
              ],
            };

      // Consider to reorder buttons except for LTO where the order is hardcoded (COPY_CODE > URL > QUICK_REPLY).
      if (!limitedTimeOffer || !limitedTimeOffer.text) {
        if (isUrlButtonAtBottom) {
          buttons.buttons.push(urlButton2ToPush);
        } else {
          buttons.buttons.splice(1, 0, urlButton2ToPush);
        }
      } else {
        buttons.buttons.splice(1, 0, urlButton2ToPush);

        if (copyCodeButton) {
          const { text } = copyCodeButton;
          const _copyCodeButton = {
            type: WhatsappTemplateButtonTypeEnum.COPY_CODE,
            example: [text],
          };
          buttons.buttons.unshift(_copyCodeButton);
        }
      }
    }

    console.info(
      "[submitTemplate] Buttons configuration (urlButton2):",
      buttons,
    );
  }

  console.info("[submitTemplate] Final template structure:", submittedTemplate);

  if (!isInPanel) {
    setProgression(0);
  }

  const response = await api.sumbitTemplateTo360Dialog({
    template: JSON.stringify(submittedTemplate),
    customerId: user.customerId,
    buttonUrlLink: urlButtonLink,
    buttonUrlLink2: urlButtonLink2,
    shouldUseRedirection:
      !urlButtonLink?.includes("{{1}}") &&
      (urlButtonTrackingEnabled ?? true) !== false,
    shouldUseRedirection2:
      !urlButtonLink2?.includes("{{1}}") &&
      (urlButton2TrackingEnabled ?? true) !== false,
    trackingEnabled: (urlButtonTrackingEnabled ?? true) !== false,
    trackingEnabled2: (urlButton2TrackingEnabled ?? true) !== false,
    officialUrlButtons: JSON.stringify(officialUrlButtons),
  });

  console.info("[submitTemplate] API response:", response);
  if (response?.success) {
    setNewTemplateName(response.templateName);
    toggleActiveSumbit();

    if (!isInPanel) {
      await delay(1200);
      for (let k = 0; k < 14; k++) {
        await delay(1500 + (-1) ** k * k * 100);
        setProgression((n) => n + 5);
      }
      await delay(1200);
      setProgression(83);
      await delay(900);
      setProgression(99);
      await delay(1000);
      setProgression(100);
    }
  } else {
    setErrorMessage(response.message);
    toggleActiveErrorSumbitting();
  }

  if (isInPanel) {
    setIsSubmitLoading(false);
  }
  return response?.success;
}
